const projects = [
    {
        title: "Pizza Blitz",
        subtitle: "Game Designer / UI Programmer",
        year: "2025",
        color: "text-red-400",
        borderColor: "#ef4444",
        engine: "Made in Unity (C#)",
        thumbnail: "/thumbnails/pizza-blitz-thumb.png",
        videos: [
            "videos/PizzaBlitz/pizza-blitz-1.mp4",
            "videos/PizzaBlitz/pizza-blitz-2.mp4",
            "videos/PizzaBlitz/pizza-blitz-3.mp4"
        ],
        platforms: ["itch", "steam"],
        playLink: "https://glumpis.itch.io/pizza-blitz",
        steam: "https://store.steampowered.com/app/3382660/Pizza_Blitz/",
        description: "First project released to Steam. Released on January 31st, 2025.",
        contributions: [
            "Designed and implemented all of the UI in the game",
            "Co-Designed core gameplay",
            "Lead most level design",
            "Designed and modelled 3D assets",
            "Some core gameplay programming"
        ],
        codeExamples: [
            {
                title: "End of Day UI",
                description: "This generates the cards at the end of the day that inform you on how you performed. This UI was vital to the player to allow them to see what pizzas they had, and hadn't delivered, as well as giving them their score. It generates an 'order' card for each order you had that day, with delay and animation, to give a popping in effect one after another.",
                code: `
	private void StartScoreDisplay()
    {
        var counter = 0.2f;
		var correctOrder = 0;

        foreach (var order in gameManager.OrdersToDeliver)
        {
            StartCoroutine(addOrderSlowly(order, counter));
            ++counter;

			if (order.score >= 100 && order.validForScoring) {
				correctOrder++;
			}
        }

		var neededScore = gameManager.scoreRequiredToPass[Mathf.Clamp(gameManager.Day - 1, 0, gameManager.daysNeededToWin)];
		var compoundScore = curScore + gameManager.scoreTime + gameManager.turretScore;
		var dayPassed = compoundScore >= neededScore;

		if (correctOrder <= 0 && dayPassed)
		{
			AcheivementManager.TryUnlockAchievement("FAILING_SUCCESSFULLY");
		}

		StartCoroutine(ShowRank(counter));
	}

	private IEnumerator addOrderSlowly(Order order, float counter)
    {
        yield return new WaitForSeconds(counter);
        var orderUI = Instantiate(completedOrder, content);
        var uiInfo = orderUI.GetComponent<CompletedOrderUI>();

        if (!order.validForScoring)
        {
            uiInfo.orderName.text = $"{order.name} (Lost)";
            uiInfo.orderName.color = new Color32(250, 143, 143, 255);
			uiInfo.sfxPlayer.PlayOneShot(uiInfo.lostClip);
        }
        else
        {
			if (order.isBurnt)
			{
				AcheivementManager.TryUnlockAchievement("BURNT_PIZZA");
			}
			
			uiInfo.orderName.text = order.name;
            
            var scoreAnim = score.GetComponent<Animator>();
            scoreAnim.SetTrigger("addScore");

			uiInfo.sfxPlayer.PlayOneShot(uiInfo.scoredClip);

			curScore += order.score;
			score.text = $"{Mathf.Floor(curScore)}";
			score.text = $"{Mathf.Floor(curScore + gameManager.scoreTime + gameManager.turretScore)}";
        }
            
        uiInfo.orderScore.text = $"{Mathf.Floor(order.score)}";
        if (!order.validForScoring)
        {
            uiInfo.orderScore.text = $"<s>{Mathf.Floor(order.score)}</s>";
            uiInfo.orderScore.color = new Color32(255, 0, 0, 255);
        }
        else
            uiInfo.orderScore.color = order.score switch
            {
                0 => new Color32(255, 70, 70, 255),
                < 50 => new Color32(250, 143, 143, 255),
                <= 75 => new Color32(255, 255, 143, 255),
                _ => new Color32(140, 255, 140, 255)
            };

        uiInfo.thumbsUp.SetActive(order.score >= 100 && order.validForScoring);
    }`
            },
            {
                title: "Shop",
                description: "This is the code that manages loading in the 'ShopItems' ScriptableObjects. It loads the ScriptableObjects from Resources then orders them by their itemCost. Then that list of shopItems is looped through, and for each index, a 'shopElement' is created. This 'shopElement' holds the necessary info to convey to the player, such as the shopItem icon, shopItem name, etc..",
                code: `
	private void LoadShopItems()
	{
		shopItems = Resources.LoadAll<ShopItem>("SOs/ShopItems").ToList();
		shopItems = shopItems.OrderByDescending(x => x.itemCost).ToList();
	}
				
	private void CreateShopItems()
	{
		LoadShopItems();
		foreach(var item in shopItems)
		{
			var temp = Instantiate(shopElement, content);

			var itemInfo = temp.GetComponent<ShopItemInfo>();
			var itemDesc = temp.GetComponent<HoveredMenuItem>();
			itemInfo.itemIcon.sprite = item.icon;
			itemInfo.itemName.text = item.itemName;
			itemInfo.itemCost.text = $"{item.itemCost}";
			itemInfo.item = item;

			itemDesc.hoverDesc = hoverDesc;
			itemDesc.description = item.description;
			itemDesc.showDefaultText = true;
			itemDesc.defaultText = "Spend points to purchase items for the pizzeria!";

			itemInfo.iconPosition.anchoredPosition += item.offset;
		}
	}`
            },
            {
                title: "Main Menu Manager",
                description: "This is a script I wrote to manage all the submenus on the main menu. I set this up so that when the player opens 'Credits' or 'Settings', opening up that submenu will close all other submenus that are open. This is to prevent screen clutter.",
                code: `
				public class MainMenuManager : MonoBehaviour
				{
					public List<GameObject> menus = new();
					public List<bool> bools = new();
			
					void Start()
					{
						for (int i = 0; i < menus.Count; i++)
						{
							bool menuOpen = false;
							bools.Add(menuOpen);
						}
					}
			
					public void SetMenuOpen(GameObject menu)
					{
						SetMenuClosed(menu);
						for (int i = 0; i < menus.Count; i++)
						{
							if (menus[i].activeInHierarchy)
							{
								bools[i] = true;
							}
						}
					}
			
					public void SetMenuClosed(GameObject menu)
					{
						for (int i = 0; i < menus.Count; ++i)
						{
							if (menus[i] != menu && menus[i].activeInHierarchy)
							{
								OpenSideMenu sideMenu = menus[i].GetComponent<OpenSideMenu>();
								sideMenu.OnClick();
								bools[i] = false;
							}
						}
					}
			
					public void CloseMenus()
					{
						for (int i = 0; i < menus.Count; ++i)
						{
							if (menus[i].activeInHierarchy)
							{
								OpenSideMenu sideMenu = menus[i].GetComponent<OpenSideMenu>();
								sideMenu.OnClick();
								bools[i] = false;
							}
						}
					}
				}`
            },
        ],
    },
];

export default projects;